/* DON'T EDIT THIS FILE: edit original and run build again */ export const spaceship = (a: any, b: any) => (a > b ? 1 : a < b ? -1 : 0);
